import * as getters from "../../baseQuestion/text/store/getters";
import * as mutations from "../../baseQuestion/text/store/mutations";
import * as actions from "../../baseQuestion/text/store/actions";
import { state as text_state } from "../../baseQuestion/text/store/state";

function state() {
	return Object.assign(
		{
			dependent_visible: "q_home_address_same_as_mailing",
			dependent_visible_values: [false, null, "", "false"]
		},
		text_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
